/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UploadingFileFromJSON, UploadingFileToJSON } from './UploadingFile';
export function UpdateChatMessageRequestFromJSON(json) {
    return UpdateChatMessageRequestFromJSONTyped(json, false);
}
export function UpdateChatMessageRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documentId: !exists(json, 'document_id') ? undefined : json['document_id'],
        message: !exists(json, 'message') ? undefined : json['message'],
        files: !exists(json, 'files') ? undefined : json['files'].map(UploadingFileFromJSON)
    };
}
export function UpdateChatMessageRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        document_id: value.documentId,
        message: value.message,
        files: value.files === undefined ? undefined : value.files.map(UploadingFileToJSON)
    };
}
